import ChatIcon from "../../../../assets/icons/messages/ChatIcon";
import DoneMarkIcon from "../../../../assets/icons/messages/DoneMarkIcon";
import NewsLetterIcon from "../../../../assets/icons/accountSidebar/NewsLetterIcon";
import TagIcon from "../../../../assets/icons/messages/TagIcon";
import UnreadIcon from "../../../../assets/icons/messages/UnreadIcon";
import LockIcon from "../../../../assets/icons/messages/LockIcon";
import EmptyMark from "../../../../assets/icons/messages/EmptyMark";
import ExitMarkIcon from "../../../../assets/icons/messages/ExitMarkIcon";
import LetterIcon from "../../../../assets/icons/messages/LetterIcon";
import LetterXIcon from "../../../../assets/icons/messages/LetterXIcon";
import NoUnreadIcon from "../../../../assets/icons/messages/NoUnreadIcon";
import UnreadEmptyIcon from "../../../../assets/icons/messages/UnreadEmptyIcon";
import LockXIcon from "../../../../assets/icons/messages/LockXIcon";
import EmptyLockIcon from "../../../../assets/icons/messages/EmptyLockIcon";

export const menuItems = [
  {
    icon: <ChatIcon />,
    label: "Каналы",
    subItems: [{ icon: <ChatIcon />, label: "Все", value: "all" }],
  },
  {
    icon: <DoneMarkIcon />,
    label: "Выполненные задачи",
    subItems: [
      { icon: <EmptyMark />, label: "Все", value: "all" },
      { icon: <DoneMarkIcon />, label: "Выполнено", value: "completed" },
      { icon: <ExitMarkIcon />, label: "Не выполнено", value: "not_completed" },
    ],
  },
  {
    icon: <NewsLetterIcon />,
    label: "Рассылка",
    subItems: [
      { icon: <LetterIcon />, label: "Все", value: "all" },
      { icon: <NewsLetterIcon />, label: "Отпарвлена", value: "completed" },
      {
        icon: <LetterXIcon />,
        label: "Не отпарвлена",
        value: "not_completed",
      },
    ],
  },

  {
    icon: <TagIcon />,
    label: "Теги",
    subItems: [{ icon: <TagIcon />, label: "Все", value: "all" }],
  },
  {
    icon: <UnreadIcon />,
    label: "Непрочитанные",
    subItems: [
      { icon: <NoUnreadIcon />, label: "Все", value: "all" },
      { icon: <UnreadEmptyIcon />, label: "Непрочитанные", value: "completed" },
    ],
  },
  {
    icon: <LockIcon />,
    label: "Забаненные",
    subItems: [
      { icon: <EmptyLockIcon />, label: "Все", value: "all" },
      { icon: <LockXIcon />, label: "Забаненные", value: "completed" },
    ],
  },
];
